<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <el-main :style="defaultHeight">
      <!--列表-->
      <el-table
        :data="listData"
        highlight-current-row
        @current-change="selectCurrentRow"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-dblclick="handleEdit"
        style="width: 100%;"
      > 
        <el-table-column
          type="selection"
          width="50"
        >
        </el-table-column>
        <el-table-column
          type="index"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="BillNo"
          label="报销单号"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CostType"
          label="费用类型"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建日期"
          :formatter="formatRBDate"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateBy"
          label="创建人"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="StatusName"
          label="状态"
          width=""
          sortable
        >
        </el-table-column>
      </el-table>
    </el-main>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      :lock-scroll=false
      title="新增"
      :visible.sync="FormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="2">
          <div>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </div>
        </el-col>
        <el-col
          :span="6"
          v-if="false"
        >
          <div>
            <el-tag>{{Hwarning}}</el-tag>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-table
          :data="addForm.Entry"
          border
          style="width: 100%; margin-top: 20px"
        >

          <el-table-column
            prop="StaffID"
            label="报销人"
            width="180"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.StaffID"
                @change="userchange(scope.row)"
                placeholder="请选择"
                filterable
              >
                <el-option
                  :key="0"
                  :label="'未选择报销人'"
                  :value="0"
                ></el-option>
                <el-option
                  v-for="item in users"
                  :key="item.uID"
                  :label="item.uRealName"
                  :value="item.uID"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="CostDepID"
            label="费用归属部门"
            width="180"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.CostDepID"
                placeholder="请选择"
                filterable
              >
                <el-option
                  :key="0"
                  :label="'未选择部门'"
                  :value="0"
                ></el-option>
                <el-option
                  v-for="item in deps"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="RBDate"
            label="费用日期"
            width="180"
          >
            <template slot-scope="scope">
              <el-date-picker
                label="zh"
                style="width:95%"
                v-model="scope.row.RBDate"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="Type"
            label="费用类型"
            width="180"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.CostTypeId"
                placeholder="请选择"
                @change="newgetbudget(scope.row)"
              >
                <el-option
                  :key="0"
                  :label="'未选择费用类型'"
                  :value="0"
                ></el-option>
                <el-option
                  v-for="item in costtypes"
                  :key="item.Id"
                  :label="item.CostTypeName"
                  :value="item.Id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="Subject"
            label="项目"
            width="180"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.Subject"
                placeholder="请选择"
                @change="newgetbudget(scope.row)"
              >
                <el-option
                  :key="0"
                  :label="'未选择项目'"
                  :value="0"
                ></el-option>
                <el-option
                  v-for="item in subjects"
                  :key="item.Number"
                  :label="item.Name"
                  :value="item.Number"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            v-if="show"
            prop="Amount"
            type='number'
            label="出差天数"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.Amount"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            v-if="show"
            prop="Amount"
            type='number'
            label="标准(餐+住)"
          >
          </el-table-column>
          <el-table-column
            prop="YSDATE"
            label="预算区间"
            width="180"
          >
            <template slot-scope="scope">
              <el-date-picker
                style="width:90%"
                v-model="scope.row.YSDATE"
                type="date"
                placeholder="选择日期"
                format="yyyy 年 MM 月 dd 日"
                :picker-options="pickerOptions"
                @change="newgetbudget(scope.row)"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="CurSurplus"
            label="剩余额度"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="YearCurSurplus"
            label="年度剩余额度"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="Amount"
            type='number'
            label="本次报销额"
            width="180"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.Amount"
                @blur="checkAmount(scope.row)"
                ref="input"
              ></el-input>
              <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteUser(scope.$index)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row
        :gutter="3"
        class="el-row"
      >
        <el-upload
          class="upload-demo"
          ref="add-upload"
          :action="UploadUrl()"
          :on-preview="handlePreview"
          :headers="headers"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handlesuccess"
          multiple
          :auto-upload="false"
        >
          <el-button
            type="primary"
            slot="trigger"
            size="small"
          >选取文件</el-button>
          <el-button
            type="success"
            v-loading.fullscreen.lock="loading"
            size="small"
            style="margin-left: 10px;"
            @click="submitUpload('add')"
          >上传到服务器</el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >文件名中不可含有特殊符号且单个文件不能超过4M</div>
        </el-upload>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="addinvoice"
          >
            手工新增
          </el-button>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="chooseMyRB"
          >
            从我的发票选择
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="addForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 40px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.Type!=99"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              type="date"
              :disabled="true"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >提交</el-button>
      </div>
    </el-dialog>
    <!--新增界面-->
    <el-dialog
      :title="title"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <div style="padding: 0,0,0">
        <div style="padding-bottom: 10px;padding-top: 0px">
          <el-row>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </el-row>
        </div>
        <div style="height:275px;overflow:auto;">
          <el-collapse
            v-model="activeNames"
            @change=""
          >
            <div
              v-for="(item, index) in DataInfo.Entry"
              :key="index"
            >
              <el-collapse-item
                class="demo-form-inline"
                :title=" typeof item.StaffName==='undefined'?'': item.StaffName +'     '+ item.CostName +'     '+item.Amount"
                :name="item.Id"
              >
                <el-form
                  :model="item"
                  class="demo-form-inline"
                  label-position="left"
                  label-width="120px"
                >

                  <!-- <el-row> <button @click="deleteUser(item.Id)">删除</button></el-row> -->
                  <el-row
                    type="flex"
                    justify="space-between"
                    style="margin-bottom: 0px"
                  >
                    <el-col :span="8">
                      <el-form-item label="报销人">
                        <el-select
                          v-model="item.StaffID"
                          placeholder="请选择"
                          @change="changeStaff(item)"
                          filterable
                        >
                          <el-option
                            :key="0"
                            :label="'未选择报销人'"
                            :value="0"
                          ></el-option>
                          <el-option
                            v-for="user in users"
                            :key="user.uID"
                            :label="user.uRealName"
                            :value="user.uID"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="费用类型">
                        <el-select
                          v-model="item.CostTypeId"
                          placeholder="请选择"
                          @change="newgetbudget(scope.row)"
                        >
                          <el-option
                            :key="0"
                            :label="'未选择费用类型'"
                            :value="0"
                          ></el-option>
                          <el-option
                            v-for="costtype in costtypes"
                            :key="costtype.Id"
                            :label="costtype.CostTypeName"
                            :value="costtype.Id"
                            :disabled="costtype.disabled"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="项目">
                        <el-select
                          v-model="item.Subject"
                          placeholder="请选择"
                          @change="newgetbudget(scope.row)"
                        >
                          <el-option
                            :key="0"
                            :label="'未选择项目'"
                            :value="0"
                          ></el-option>
                          <el-option
                            v-for="subject in subjects"
                            :key="subject.Number"
                            :label="subject.Name"
                            :value="subject.Number"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    justify="space-between"
                    style="margin-bottom: 0px"
                  >
                    <el-col :span="8">
                      <el-form-item label="费用归属部门">
                        <el-select
                          v-model="item.CostDepID"
                          placeholder="请选择"
                          filterable
                        >
                          <el-option
                            :key="0"
                            :label="'未选择部门'"
                            :value="0"
                          ></el-option>
                          <el-option
                            v-for="dep in deps"
                            :key="dep.Id"
                            :label="dep.Name"
                            :value="dep.Id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="费用日期">
                        <el-date-picker
                          label="zh"
                          v-model="item.RBDate"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预算区间">
                        <el-date-picker
                          v-model="item.YSDATE"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy 年 MM 月 dd 日"
                          :picker-options="pickerOptions"
                          @change="newgetbudget(scope.row)"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    style="margin-bottom: 0px"
                    type="flex"
                    justify="space-between"
                  >
                    <el-col :span="8">
                      <el-form-item label="剩余额度">
                        <el-input
                          style="width: 70%"
                          v-model="item.CurSurplus"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label-width="120px"
                        label="年度剩余额度"
                      >
                        <el-input
                          style="width: 70%"
                          v-model="item.YearCurSurplus"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="本次报销额"
                        label-width="120px"
                      >
                        <el-input
                          style="width: 70%"
                          v-model="item.Amount"
                          @blur="checkAmount(scope.row)"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-row
                  type="flex"
                  justify="end"
                  style="padding-right: 20px"
                >
                  <button
                    type="primary"
                    @click="deleteUser(index)"
                  >删除</button>
                </el-row>
              </el-collapse-item>
            </div>

          </el-collapse>

        </div>
        <div style="padding-top: 0px">
          <el-row
            :gutter="3"
            class="el-row"
          >
            <el-upload
              class="upload-demo"
              ref="add-upload"
              :action="UploadUrl()"
              :on-preview="handlePreview"
              :headers="headers"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handlesuccess"
              multiple
              :auto-upload="false"
            >
              <el-button
                type="primary"
                slot="trigger"
                size="small"
              >选取文件</el-button>
              <el-button
                type="success"
                v-loading.fullscreen.lock="loading"
                size="small"
                style="margin-left: 10px;"
                @click="submitUpload('add')"
              >上传到服务器</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >文件名中不可含有特殊符号且单个文件不能超过4M</div>
            </el-upload>
            <el-col :span="2">
              <el-button
                type="primary"
                size="small"
                @click="addinvoice"
              >
                手工新增
              </el-button>
            </el-col>
            <el-col :span="2">
              <el-button
                type="primary"
                size="small"
                @click="chooseMyRB"
              >
                从我的发票选择
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div style="height:300px;overflow:auto;">
          <el-table
            :data="editForm.EntryInvoiceinfo"
            border
            style="width: 100%; margin-top: 40px;"
          >

            <el-table-column
              prop="InvoiceName"
              label="发票名称"
              width="180"
            >

            </el-table-column>
            <el-table-column
              prop="InvoiceNo"
              label="发票号码"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="ItemName"
              label="项目名称"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.ItemName"
                  :disabled="scope.row.Type!=99"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column
              :formatter="formatData"
              prop="InvoiceDate"
              label="开票日期"
            >
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.InvoiceDate"
                  align="right"
                  style="width:90%"
                  :disabled="true"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </template>

            </el-table-column>
            <el-table-column
              prop="Amount"
              label="金额"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Amount"
                  :disabled="scope.row.Type!=99"
                  @blur="getfpsum($event)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="Count"
              label="张数"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Count"
                  :disabled="scope.row.Type!=99"
                  @blur="getfpsum($event)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="发票状态"
              width="180"
            >
              <template slot-scope="scope">
                <div
                  slot="reference"
                  class="name-wrapper"
                >
                  <el-tag
                    size="medium"
                    :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                  >{{ scope.row.StatusInfo }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  @click="deleteInvoice(scope.row)"
                  type="text"
                  size="small"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table style="width: 100%; margin-top: 40px;">
        </div>
        <div slot="footer">
          <el-row
            type="flex"
            justify="end"
          >
            <el-button @click.native="addFormVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click.native="addSubmit"
              :loading="addLoading"
            >提交</el-button>
          </el-row>

        </div>
      </div>
    </el-dialog>

    <!--测试界面-->
    <el-dialog
      :title="title"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <div style="padding: 0,0,0">
        <div style="padding-bottom: 10px;padding-top: 0px">
          <el-row>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </el-row>
        </div>
        <div style="height:275px;overflow:auto;">
          <el-collapse
            v-model="activeNames"
            @change=""
          >
            <div
              v-for="(item, index) in DataInfo.Entry"
              :key="index"
            >
              <el-tabs tab-position="left">
                <el-tab-pane
                  :label="item.StaffName"
                  style="margin-top: 5px;"
                >
                  <el-form
                    :model="item"
                    class="demo-form-inline"
                    label-position="left"
                    label-width="120px"
                  >

                    <!-- <el-row> <button @click="deleteUser(item.Id)">删除</button></el-row> -->
                    <el-row
                      type="flex"
                      justify="space-between"
                      style="margin-bottom: 0px"
                    >
                      <el-col :span="8">
                        <el-form-item label="报销人">
                          <el-select
                            v-model="item.StaffID"
                            @change="changeStaff(item)"
                            placeholder="请选择"
                            filterable
                          >
                            <el-option
                              :key="0"
                              :label="'未选择报销人'"
                              :value="0"
                            ></el-option>
                            <el-option
                              v-for="user in users"
                              :key="user.uID"
                              :label="user.uRealName"
                              :value="user.uID"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="费用类型">
                          <el-select
                            v-model="item.CostTypeId"
                            placeholder="请选择"
                            @change="newgetbudget(scope.row)"
                          >
                            <el-option
                              :key="0"
                              :label="'未选择费用类型'"
                              :value="0"
                            ></el-option>
                            <el-option
                              v-for="costtype in costtypes"
                              :key="costtype.Id"
                              :label="costtype.CostTypeName"
                              :value="costtype.Id"
                              :disabled="costtype.disabled"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="项目">
                          <el-select
                            v-model="item.Subject"
                            placeholder="请选择"
                            @change="newgetbudget(scope.row)"
                          >
                            <el-option
                              :key="0"
                              :label="'未选择项目'"
                              :value="0"
                            ></el-option>
                            <el-option
                              v-for="subject in subjects"
                              :key="subject.Number"
                              :label="subject.Name"
                              :value="subject.Number"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                      style="margin-bottom: 0px"
                    >
                      <el-col :span="8">
                        <el-form-item label="费用归属部门">
                          <el-select
                            v-model="item.CostDepID"
                            placeholder="请选择"
                            filterable
                          >
                            <el-option
                              :key="0"
                              :label="'未选择部门'"
                              :value="0"
                            ></el-option>
                            <el-option
                              v-for="dep in deps"
                              :key="dep.Id"
                              :label="dep.Name"
                              :value="dep.Id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="费用日期">
                          <el-date-picker
                            label="zh"
                            v-model="item.RBDate"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="预算区间">
                          <el-date-picker
                            v-model="item.YSDATE"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            :picker-options="pickerOptions"
                            @change="newgetbudget(scope.row)"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row
                      style="margin-bottom: 0px"
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="8">
                        <el-form-item label="剩余额度">
                          <el-input
                            style="width: 70%"
                            v-model="item.CurSurplus"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          label-width="120px"
                          label="年度剩余额度"
                        >
                          <el-input
                            style="width: 70%"
                            v-model="item.YearCurSurplus"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          label="本次报销额"
                          label-width="120px"
                        >
                          <el-input
                            style="width: 70%"
                            v-model="item.Amount"
                            @blur="checkAmount(scope.row)"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-tab-pane>

              </el-tabs>
            </div>

          </el-collapse>

        </div>
        <div style="padding-top: 0px">
          <el-row
            :gutter="3"
            class="el-row"
          >
            <el-upload
              class="upload-demo"
              ref="add-upload"
              :action="UploadUrl()"
              :on-preview="handlePreview"
              :headers="headers"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="handlesuccess"
              multiple
              :auto-upload="false"
            >
              <el-button
                type="primary"
                slot="trigger"
                size="small"
              >选取文件</el-button>
              <el-button
                type="success"
                v-loading.fullscreen.lock="loading"
                size="small"
                style="margin-left: 10px;"
                @click="submitUpload('add')"
              >上传到服务器</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >文件名中不可含有特殊符号且单个文件不能超过4M</div>
            </el-upload>
            <el-col :span="2">
              <el-button
                type="primary"
                size="small"
                @click="addinvoice"
              >
                手工新增
              </el-button>
            </el-col>
            <el-col :span="2">
              <el-button
                type="primary"
                size="small"
                @click="chooseMyRB"
              >
                从我的发票选择
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div style="height:300px;overflow:auto;">
          <el-table
            :data="editForm.EntryInvoiceinfo"
            border
            style="width: 100%; margin-top: 40px;"
          >

            <el-table-column
              prop="InvoiceName"
              label="发票名称"
              width="180"
            >

            </el-table-column>
            <el-table-column
              prop="InvoiceNo"
              label="发票号码"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="ItemName"
              label="项目名称"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.ItemName"
                  :disabled="scope.row.Type!=99"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column
              :formatter="formatData"
              prop="InvoiceDate"
              label="开票日期"
            >
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.InvoiceDate"
                  align="right"
                  style="width:90%"
                  :disabled="true"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </template>

            </el-table-column>
            <el-table-column
              prop="Amount"
              label="金额"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Amount"
                  :disabled="scope.row.Type!=99"
                  @blur="getfpsum($event)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="Count"
              label="张数"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.Count"
                  :disabled="scope.row.Type!=99"
                  @blur="getfpsum($event)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="发票状态"
              width="180"
            >
              <template slot-scope="scope">
                <div
                  slot="reference"
                  class="name-wrapper"
                >
                  <el-tag
                    size="medium"
                    :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                  >{{ scope.row.StatusInfo }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  @click="deleteInvoice(scope.row)"
                  type="text"
                  size="small"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table style="width: 100%; margin-top: 40px;">
        </div>
        <div slot="footer">
          <el-row
            type="flex"
            justify="end"
          >
            <el-button @click.native="addFormVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click.native="addSubmit"
              :loading="addLoading"
            >提交</el-button>
          </el-row>

        </div>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="2">
          <div>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </div>
        </el-col>
        <el-col
          :span="6"
          v-if="false"
        >
          <div>
            <el-tag>{{Hwarning}}</el-tag>
          </div>
        </el-col>
      </el-row>

      <el-table
        :data="editForm.Entry"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="StaffID"
          label="报销人"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.StaffID"
              @change="userchange(scope.row)"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择报销人'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in users"
                :key="item.uID"
                :label="item.uRealName"
                :value="item.uID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="CostDepID"
          label="费用归属部门"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostDepID"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择部门'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in deps"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="RBDate"
          label="费用日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:95%"
              v-model="scope.row.RBDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="费用类型"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostTypeId"
              placeholder="请选择"
              @change="newgetbudget(scope.row)"
            >
              <el-option
                :key="0"
                :label="'未选择费用类型'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in costtypes"
                :key="item.Id"
                :label="item.CostTypeName"
                :value="item.Id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Subject"
          label="项目"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.Subject"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择项目'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in subjects"
                :key="item.Number"
                :label="item.Name"
                :value="item.Number"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="出差天数"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="标准(餐+住)"
        >
        </el-table-column>
        <el-table-column
          prop="YSDATE"
          label="预算区间"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:90%"
              v-model="scope.row.YSDATE"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
              @change="newgetbudget(scope.row)"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="CurSurplus"
          label="剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="YearCurSurplus"
          label="年度剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          type='number'
          label="本次报销额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              @blur="checkAmount(scope.row)"
              ref="input"
            ></el-input>
            <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteUser(scope.$index)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row
        :gutter="3"
        class="el-row"
      >
        <el-upload
          class="upload-demo"
          ref="edit-upload"
          :action="UploadUrl()"
          :headers="headers"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handlesuccess"
          multiple
          :auto-upload="false"
        >
          <el-button
            type="primary"
            slot="trigger"
            size="small"
          >选取文件</el-button>
          <el-button
            v-loading.fullscreen.lock="loading"
            type="success"
            size="small"
            style="margin-left: 10px;"
            @click="submitUpload('edit')"
          >上传到服务器</el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >文件名中不可含有特殊符号且单个文件不能超过4M</div>
        </el-upload>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="addinvoice"
          >
            手工新增
          </el-button>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            @click="chooseMyRB"
          >
            从我的发票选择
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="editForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 40px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.Type!=99"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table style="width: 100%; margin-top: 40px;">
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog
      title="查看"
      :visible.sync="readFormVisible"
      v-model="readFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-table
        :data="editForm.Entry"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="StaffID"
          label="报销人"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.StaffID"
              :disabled="true"
              @change="userchange(scope.row)"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择报销人'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in users"
                :key="item.uID"
                :label="item.uRealName"
                :value="item.uID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="CostDepID"
          label="费用归属部门"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="true"
              v-model="scope.row.CostDepID"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择部门'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in deps"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="RBDate"
          label="费用日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:95%"
              v-model="scope.row.RBDate"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="费用类型"
        >
          <template slot-scope="scope">
            <el-select
              :disabled="true"
              v-model="scope.row.CostTypeId"
              placeholder="请选择"
              @change="newgetbudget(scope.row)"
            >
              <el-option
                :key="0"
                :label="'未选择费用类型'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in costtypes"
                :key="item.Id"
                :label="item.CostTypeName"
                :value="item.Id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Subject"
          label="项目"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.Subject"
              placeholder="请选择"
              :disabled="true"
            >
              <el-option
                :key="0"
                :label="'未选择项目'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in subjects"
                :key="item.Number"
                :label="item.Name"
                :value="item.Number"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="出差天数"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="标准(餐+住)"
        >
        </el-table-column>
        <el-table-column
          prop="YSDATE"
          label="预算区间"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:90%"
              v-model="scope.row.YSDATE"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
              @change="newgetbudget(scope.row)"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="CurSurplus"
          label="剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="YearCurSurplus"
          label="年度剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          type='number'
          label="本次报销额"
        >
          <template slot-scope="scope">
            <el-input
              :disabled="true"
              v-model="scope.row.Amount"
              @blur="checkAmount(scope.row)"
              ref="input"
            ></el-input>
            <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              :disabled="true"
              @click="deleteUser(scope.$index)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        :data="editForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 40px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.disabled"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              :disabled="true"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.disabled"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.disabled"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              :disabled="true"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table style="width: 100%; margin-top: 40px;">
    </el-dialog>

    <!--我的发票界面-->
    <el-dialog
      title="我的发票"
      :visible.sync="myRBFormVisible"
      v-model="myRBFormVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <template>
        <el-row>
          <el-table
            :data="myRB"
            @selection-change="myRBselsChange"
            @row-dblclick="handleEdit"
            @current-change="myRBselectCurrentRow"
          >
            <el-table-column
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column
              type="index"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="InvoiceName"
              label="发票名称"
              width="180"
            >

            </el-table-column>
            <el-table-column
              prop="InvoiceNo"
              label="发票号码"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="ItemName"
              label="项目名称"
            >
            </el-table-column>
            </el-table-column>
            <el-table-column
              :formatter="formatData"
              prop="InvoiceDate"
              sortable
              label="开票日期"
            >
            </el-table-column>
            <el-table-column
              :formatter="formatData2"
              prop="ModifyTime"
              sortable
              label="最近更新日期"
            >
            </el-table-column>
            <el-table-column
              prop="Amount"
              sortable
              label="金额"
            >
            </el-table-column>
            <el-table-column
              prop="Count"
              label="张数"
            >
            </el-table-column>
            <el-table-column
              label="发票状态"
              width="180"
            >
              <template slot-scope="scope">
                <div
                  slot="reference"
                  class="name-wrapper"
                >
                  <el-tag
                    size="medium"
                    :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                  >{{ scope.row.StatusInfo }}</el-tag>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!--工具条-->
        <el-col
          :span="24"
          class="toolbar"
        >
          <el-pagination
            layout="prev, pager, next"
            @current-change="myRBhandleCurrentChange"
            :page-size="1000"
            :total="myRBtotal"
            style="float:right;"
          >
          </el-pagination>
        </el-col>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click.native="myRBFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="SubmitChooseinvoice"
          >提交</el-button>
        </div>
      </template>
    </el-dialog>

    <!--下推界面-->
    <el-dialog
      title="报销说明"
      :visible.sync="pushFormVisible"
      v-model="pushFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item>
              <div style="font-size:16px">发生“招待费”和“其他费用”时，列出何处发生，联系人姓名，职务，代表公司
                发生“差旅费”，列明出差事由。</div>
              <div style="font-size:16px">如有新项目，请写明。</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">

          <el-col :span="24">
            <el-form-item
              label="说明"
              prop="Remark"
            >
              <el-input
                :rows="4"
                type="textarea"
                v-model="pushForm.Remark"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="pushFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="pushSubmit"
          :loading="listLoading"
        >保存</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from '../../../util/date'
import { testapi, getUserListPage, PushRB, getListInvoicePage, removeRB, SubmitRB, batchRemoveUser, addRB, getDepListPage, getDictionaryListPage, getRBListPage, getCostTypeListPage, getbudget, checkRB, editRB, ReSubmitRB } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import printmb from "../../printer/mb/rbprinter2";
import Cookies from 'js-cookie'

export default {
  components: { Toolbar },
  data() {
    return {
      title: '',
      DataInfo: { Entry: {} },
      FormVisible: false,
      activeNames: [],
      pickerOptions: {
        disabledDate(v) {
          // return v.getTime() < new Date().getTime() - 86400000;
          // return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      filters: {
        name: ''
      },
      headers: {
        Authorization: ''
      },
      defaultHeight: {
        height: ""
      },
      Hwarning: 'aa',
      fileList: [],
      huanjing: '',
      users: [],
      show: false,
      listData: [],
      reuser: [],
      deps: [],
      subjects: [],
      costtypes: [],
      roles: [],
      total: 0,
      myRBtotal: 0,
      buttonList: [],
      currentRow: null,
      myRBcurrentRow: null,
      page: 1,
      myRBpage: 1,
      listLoading: false,
      loading: false,
      sels: [],//列表选中列
      myRBsels: [],//列表选中列
      UploadPath: '',
      testUploadPath: '',
      DownPath: '',
      testDownPath: '',
      InvoiceInfo: [],
      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      readFormVisible: false,//查看界面是否显示
      myRBFormVisible: false,//我的发票界面是否显示
      pushFormVisible: false,//下推界面是否显示
      xxFormVisible: false,
      editLoading: false,
      readLoading: false,
      editFormRules: {
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      },
      //编辑界面数据
      readForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      },
      pushForm: {
        Remark: ''
      },
      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
      },
      //新增界面数据
      addForm: {
        Entry: {}
      }
      ,
      myRB: [],
      RBData: [],
      spanArr: [],
      spanArr2: []
    }
  },
  methods: {
    changeStaff(e) {
      this.users.forEach(function(item) {
        if (item.uID == e.StaffID) {
          e.StaffName = item.uRealName
        }
      });
    },
    getHeight() {
      // this.defaultHeight.height = window.innerHeight - 250 + "px";
    },
    checkAmount(row) {
      var rows = [];
      rows.push(row);
      var msg = this.checkAmounts(rows);
      if (msg.length > 0) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: "error"
        });
      }
    },
    checkAmounts(rows) {
      var message = '';
      rows.forEach(function(item) {
        if (item.Amount > item.CurSurplus) {
          message = '超额！请重输或与财务确认！' + '<br/>';
        }
        if (item.Amount < item.YearCurSurplus && item.Amount > item.CurSurplus) {
          message = '本月超额！请尝试次月报销或与财务确认！' + '<br/>';
        }
      });
      return message;
    },

    addreuser() {
      //控制只让选一种费用类型
      var tmp = this.DataInfo;
      if (tmp.Entry.length > 0) {
        var tmpCostType = tmp.Entry[0].CostTypeId;
        this.costtypes.forEach(function(item) {
          if (item.Id != tmpCostType) {
            item['disabled'] = true;
          }
        });
      }
      var userid = JSON.parse(window.localStorage.user).uID;
      var tmpid = 'tmp' + tmp.Entry.length
      tmp.Entry.push({
        Id: tmpid,
        StaffID: tmp.Entry.length === 0 ? userid : '',
        DepID: '',
        CostDepID: '',
        CostTypeId: '',
        Amount: 0,
        CurBudget: 0,
        CurSurplus: 0,
        Subject: '002',
        RBDate: new Date()
      }
      );
      this.activeNames.push(tmpid)
      console.log(tmp.Entry);
      if (tmp.Entry.length === 1) this.userchange(tmp.Entry[0])
      console.log(this.activeNames);
    },
    getNow() {
      let dateTime
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
        :
        new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
        :
        new Date().getSeconds()
      dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
      console.log(dateTime)
      return dateTime
    },
    deleteUser(index) {
      console.log('aa')
      var tmp = this.DataInfo;
      // let index = mList.findIndex(item => {
      //   return item.id === Id;
      // });
      tmp.Entry.splice(index, 1);

      //解除控制只让选一种费用类型
      if (tmp.Entry.length == 1) {
        this.costtypes.forEach(function(item) {
          item['disabled'] = false;
        });
      }
    },
    addinvoice() {
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      tmp.EntryInvoiceinfo.splice(0, 0, {
        Status: '0',
        StatusInfo: '正确',
        InvoiceName: '手工新增',
        InvoiceDate: this.getNowFormatDate(),
        Count: 1,
        Type: 99,
        disabled: false,
        InvoiceNo: 'tmp' + tmp.EntryInvoiceinfo.length
      });
    },
    chooseMyRB() {
      this.myRB = [];
      this.handlegetmyRB();
      this.myRBFormVisible = true;
    },
    SubmitChooseinvoice() {
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      var items = this.myRBsels.map((item) => item);
      items.forEach(function(element) {
        element.disabled = true,
          // tmp.EntryInvoiceinfo.push(element);
          tmp.EntryInvoiceinfo.splice(0, 0, element);
      })
      this.myRBFormVisible = false;
      this.getfpsum();
    },
    //双击选择发票
    handleChoose() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择一行数据！",
          type: "error"
        });
        return;
      }
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      tmp.EntryInvoiceinfo.splice(0, 0, row);
    },
    deleteInvoice(row) {

      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      const index = tmp.EntryInvoiceinfo.findIndex(a => a.InvoiceNo === row.InvoiceNo);
      tmp.EntryInvoiceinfo.splice(index, 1);
      const index2 = this.fileList.findIndex(text => text.name === row.FileName);
      this.fileList.splice(index2, 1);
      this.getfpsum();
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getfpsum(isupdate) {
      var tmp = this.editFormVisible == true || this.readFormVisible == true ? this.editForm : this.addForm;
      //删除原合计
      const index = tmp.EntryInvoiceinfo.findIndex(text => text.InvoiceName === '合计');
      if (index != -1) tmp.EntryInvoiceinfo.splice(index, 1);
      if (tmp.EntryInvoiceinfo.length > 0) {
        //求合计
        var s = 0;
        var s2 = 0;
        var z1 = '0';
        var z2 = '通过';
        tmp.EntryInvoiceinfo.forEach(function(val, idx, arr) {

          // var aa = parseFloat(val.Amount);
          // s = s + aa;
          s += parseFloat(val.Amount);
          s2 += parseFloat(val.Count);
          if (val.Status != '0' && val.Status != '1') {
            z1 = '2';
            z2 = '错误';
          }
        }, 0);
        s = s.toFixed(2);
        // s2 = s2.toFixed(2);

        //判断整体状态
        var heji = {
          InvoiceName: '合计',
          Amount: s,
          Count: s2,
          Status: z1,
          disabled: true,
          StatusInfo: z2,
          Type: 100
        };
        tmp.EntryInvoiceinfo.push(heji);

        // if (tmp.Entry.length === 1 && (tmp.Entry[0].Amount === 0)) {
        if (isupdate != 1) {
          tmp.Entry[0].Amount = s;
        }
        // }
      }

    },
    userchange(row) {
      var depid = this.users.filter((user) => user.uID === row.StaffID)[0].DepID;
      var tmp = this.DataInfo;
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.DepID = depid;
          item.CostDepID = depid;
          item.Subject = '002';
          item.CurBudget = 0;
          item.CurSurplus = 0;
          item.CostTypeId = '';
        }
      });
    },
    //获取剩余额度
    newgetbudget(row) {

      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;

      //校验前置条件
      if (row.StaffID.length == 0) {
        this.$message({
          message: '请选择报销人后再选择费用类型',
          type: 'error'
        });

        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CostTypeId = '';
          }
        });
        tmpload.close();
        return;
      }
      //先把额度置零
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.CurBudget = 0;
          item.CurSurplus = 0;
        }
      });

      //转换部门编码,后端需要
      this.deps.forEach(function(item) {
        if (item.Id == row.CostDepID) {
          row.DepNo = item.Number;
        }
      });

      //转换项目编码,后端需要
      // this.subjects.forEach(function(item) {
      //   if (item.Id == row.CostDepID) {
      //     row.Subject = item.Number;
      //   }
      // });

      let para = row;
      getbudget(para).then((res) => {
        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CurBudget = res.data.response.CurBudget;
            item.CurSurplus = res.data.response.CurSurplus;
            item.YearCurSurplus = res.data.response.YearCurSurplus;
          }
        })
      })
      tmpload.close();
    },
    getallbudget() {
      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      var _this = this;
      this.editForm.Entry.forEach(function(item) {
        item.CurBudget = 0;
        item.CurSurplus = 0;

        _this.deps.forEach(function(item2) {
          if (item2.Id == item.CostDepID) {
            item.DepNo = item2.Number;
          }
        });

        let para = item;
        getbudget(para).then((res) => {
          item.CurBudget = res.data.response.CurBudget;
          item.CurSurplus = res.data.response.CurSurplus;
          item.YearCurSurplus = res.data.response.YearCurSurplus;
        })
      });
      tmpload.close();
    },

    UploadUrl: function() {
      var UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
      return UploadPath;
    },
    handlesuccess(response, file, fileList) {
      debugger
      if (response.success == true) {

        var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
        for (let index = 0; index < response.response.length; index++) {
          var tmpresponse = response.response[index];
          //如果该发票不在明细内则加入
          if (tmp.EntryInvoiceinfo.filter((item, i) => {
            return item.InvoiceNo == tmpresponse.InvoiceNo;
          }).length == 0) {
            tmp.EntryInvoiceinfo.push(tmpresponse); //加到发票明细中
            // fileList.find(a => a.name == file.name).name = tmpresponse.FileName;//文件改名
          }
          // else { //如果发票重复上传，自动删除
          //   const index = fileList.findIndex(text => text.name === file.name);
          //   fileList.splice(index, 1);
          // }
        }
        this.getfpsum();
      }
      else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error',
          duration: 0
        });
      }

      this.loading = false;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
      // if (file.status == 'success') {
      //   var fileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/File/DownFile/' : 'http://localhost:1003/api/File/DownFile/';
      //   let para = file.name;
      //   axios({
      //     // 用axios发送post请求
      //     method: "post",
      //     url: fileurl + "?filename=" + para, // 请求地址 ，也可以传递参数
      //     responseType: "blob" // 表明返回服务器返回的数据类型
      //   }).then((res) => {
      //     var content = res.data;
      //     var blob = new Blob([content]);
      //     var url = URL.createObjectURL(blob);
      //     let link = document.createElement('a')
      //     link.style.display = 'none'
      //     link.href = url
      //     link.setAttribute('download', file.name)
      //     document.body.appendChild(link)
      //     link.click()
      //   });
      // }
    },
    submitUpload(AddorEdit) {

      if (AddorEdit == 'edit') {
        this.$refs['edit-upload'].submit();
      }
      else {
        this.$refs['add-upload'].submit();
      }
      this.loading = true;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    myRBselectCurrentRow(val) {
      this.myRBcurrentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    formatRBDate: function(row, column) {
      var a = (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm:ss')
      return a;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },
    myRBhandleCurrentChange(val) {
      this.myRBpage = val;
      this.handlegetmyRB();
    },

    //获取列表
    handleget() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;
      testapi();
      getRBListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.listData = res.data.response.data;
        this.listData.forEach(function(item) {
          item.EntryInvoiceinfo.forEach(function(item2) {
            item2['disabled'] = true;
          });
        });
        this.listLoading = false;
      });
    },
    //获取列表
    handlegetmyRB() {
      let para = {
        page: this.myRBpage,
        key: '0'
      };
      getListInvoicePage(para).then((res) => {
        this.myRBtotal = res.data.response.dataCount;
        this.myRB = res.data.response.data;
      });
    },
    //下推
    handlePush() {
      var items = this.sels.map((item) => item);
      var checkstatus = true;
      items.forEach(function(element) {
        if (element.Status != "0") checkstatus = false
      })
      if (checkstatus == false) {
        this.listLoading = false;
        this.$message({
          message: "所选申请单存在状态不符合，请刷新后重试",
          type: "error"
        });
        return;
      }
      if (items.length === 0) {
        this.listLoading = false;
        this.$message({
          message: "请勾选需要下推的数据行！",
          type: "error"
        });
        return;
      }

      this.pushFormVisible = true;

    },
    go(path) {
      this.$router.replace({
        path: path,
      });
    },
    //获取用户列表
    getUsers() {
      getUserListPage().then((res) => {
        this.users = res.data.response.data;
      });
    },
    //获取部门列表
    getDeps() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getDepListPage(para).then((res) => {
        this.deps = res.data.response.data;
        this.listLoading = false;
      });
    },
    //获取项目
    getSubjects() {
      var filters = {
        name: 'SUBJECTS'
      };
      let para = {
        page: this.page,
        key: filters.name
      };
      this.listLoading = true;

      getDictionaryListPage(para).then((res) => {
        this.subjects = res.data.response.data[0].Entry;
        this.listLoading = false;
      });
    },
    //获取费用类型列表
    getCosts() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getCostTypeListPage(para).then((res) => {
        this.costtypes = res.data.response.data;
        this.listLoading = false;
      });
    },

    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.editForm = Object.assign({}, row);
      this.xxFormVisible = true;
      for (let index = 0; index < this.editForm.Entry.length; index++) {
        this.activeNames.push(this.editForm.Entry[index].Id)
      }

      console.log('activeNames', this.activeNames);
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要编辑的一行数据！",
      //     type: "error"
      //   });

      //   return;
      // }

      // if (row.Status == '1') {
      //   this.readFormVisible = true;
      // }
      // else {
      //   this.editFormVisible = true;
      // }
      // this.editForm = Object.assign({}, row);

      // this.getfpsum(1);
      // this.getallbudget();
    },
    //显示新增界面
    handleAdd() {
      this.title = '新增';
      this.FormVisible = true;
      this.fileList = [];
      this.DataInfo = {
        Amount: 0,
        YSDATE: '',
        Entry: [],
        EntryInvoiceinfo: []
      };
      this.addreuser();
      for (let index = 0; index < this.DataInfo.Entry.length; index++) {
        this.activeNames.push(this.DataInfo.Entry[index].Id)
      }
    },
    //审核
    handCheck() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要审核的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '1') {
        this.$message({
          message: "只有提交状态可审核！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认审核吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        checkRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '审核成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //下推
    pushSubmit() {
      var message = this.pushForm.Remark;
      message = message.replace(/^\s*|\s*$/g, ''); // 去除字符串内两头的空格
      if (message.length === 0) {
        this.listLoading = false;
        this.$message({
          message: "填写报销说明！",
          type: "error"
        });
        return;
      }
      this.$confirm("确认下推选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {

          this.listLoading = true;
          var para = {
            message: this.pushForm.Remark,
            ids: []
          };
          var items = this.sels.map((item) => item);
          items.forEach(function(element) {
            para.ids.push(element.Id);
          });


          // para = JSON.stringify(para)

          PushRB(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.pushFormVisible = false;
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: '下推成功',
                type: 'success'
              });
              this.pushFormVisible = false;
              this.handleget();
              this.go("/ListReimbursement/ListReimbursement");
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          })
            ;
        })
        .catch(() => { this.listLoading = false; });
    },
    //提交
    handleSubmit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要提交的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '0') {
        this.$message({
          message: "只有创建状态可提交！",
          type: "error"
        });
        return;
      }
      this.newgetbudget();
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        SubmitRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //反提交
    handleRSubmit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要反提交的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '1') {
        this.$message({
          message: "只有提交状态可反提交！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认反提交吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        ReSubmitRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '反提交成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //打印
    handlePrinter() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择一行数据！",
          type: "error"
        });
        return;
      }
      var _this = this;
      row.Entry.forEach(function(item) {
        item.SubjectName = _this.subjects.find(a => a.Number == item.Subject).Name;
        item.YSDATE = (!item.YSDATE || item.YSDATE == '') ? '' : util.formatDate.format(new Date(item.YSDATE), 'yyyy-MM')
      });

      printmb(row);
    },
    //编辑
    editSubmit: function() {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.editLoading = true;

        var msg = this.Verification(this.editForm);
        if (msg.length > 0) {
          this.editLoading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: msg,
            type: 'error',
            duration: 0
          });
          return;
        }
        let para = Object.assign({}, this.editForm);
        editRB(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.editLoading = false;
            return;
          }
          if (res.data.success) {
            this.editLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.editFormVisible = false;
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      });
    },
    //新增
    addSubmit: function() {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true;

        var msg = this.Verification(this.addForm);
        if (msg.length > 0) {
          this.addLoading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: msg,
            type: 'error',
            duration: 0
          });
          return;
        }
        let para = Object.assign({}, this.addForm);

        addRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.addLoading = false;
            return;
          }
          if (res.data.success) {
            this.addLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.addFormVisible = false;
            this.handleget();
          }
          else {
            this.addLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'error'
            });

          }
        });
      });
    },
    Verification(info) {
      var msg = '';
      //校验预算额度
      msg = this.checkAmounts(info.Entry);

      //校验
      if (info.Entry.length < 1) msg += "请选择报销人！<br/>";
      //校验
      if (info.EntryInvoiceinfo.length < 1) msg += "请上传发票！<br/>";

      var ispass = false;
      //校验
      info.Entry.forEach(function(item) {
        if (item.Amount == 0) ispass = true;
      });
      if (ispass) {
        msg += "报销金额不能为0<br/>";
        ispass = false
      }

      //发票信息校验
      info.EntryInvoiceinfo.forEach(function(item) {
        if (item.Status == '2') ispass = true;
      });
      if (ispass) {
        msg += "存在发票信息校验失败，请检查或删除该发票！<br/>";
      }


      //校验发票总额与报销额总额
      var bxsum = 0;
      var fpsum = 0;
      info.Entry.forEach(function(val, idx, arr) {
        bxsum += parseFloat(val.Amount);
      }, 0);

      var tmp = info.EntryInvoiceinfo.filter((a) => a.InvoiceName != '合计');
      tmp.forEach(function(val, idx, arr) {
        fpsum += parseFloat(val.Amount);
      }, 0);
      bxsum = Number(bxsum.toFixed(2));
      fpsum = Number(fpsum.toFixed(2));


      if (bxsum > fpsum) {
        msg += "发票总额低于报销总额，请检查！<br/>";
      }
      return msg;
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (row.Status == "1") {
        this.$message({
          message: "该申请单已锁定，请前往报销单撤销后再进行操作！",
          type: "error"
        });
        return;
      }
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { Id: row.Id };
        removeRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.handleget();
        });
      }).catch(() => {
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    myRBselsChange: function(sels) {
      this.myRBsels = sels;
    },
    formatData: function(row, column) {
      return (!row.InvoiceDate || row.InvoiceDate == '') ? '' : util.formatDate.format(new Date(row.InvoiceDate), 'yyyy-MM-dd');
    },
    formatData2: function(row, column) {
      return (!row.ModifyTime || row.ModifyTime == '') ? '' : util.formatDate.format(new Date(row.ModifyTime), 'yyyy-MM-dd');
    }
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.getHeight);
    //一定记得在页面关闭前销毁监听的resize事件，不然多次刷新后页面会因为内存泄漏崩溃
  },
  mounted() {
    // window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.handleget();
    this.getUsers();
    this.getDeps();
    this.getCosts();
    this.getSubjects();
    this.addForm.Entry = [];

    let tokenStr = window.localStorage.Token;
    this.headers = {
      Authorization: "Bearer " + tokenStr
    };

    this.huanjing = process.env.NODE_ENV;
    UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style >
.el-badge__content.is-fixed {
  right: 0;
}
::v-deep .el-collapse-item_header {
  font-size: 20px;
  font-weight: 700;
}
.demo-form-inline {
  background-color: rgb(167, 229, 243);
}
::v-deep .el-tabs__item {
  width: 100px;
}
.el-collapse-item__wrap {
  background-color: transparent;
  color: #fff;
}
</style>
